// Jedinice mere za namirnice
export const UNIT_OPTIONS = [
    { value: 'g', label: 'g', grams: 1 },
    { value: 'ml', label: 'ml', grams: 1 },
    { value: 'kom', label: 'kom', grams: 100 },
    { value: 'sk', label: 'sup. kašika', grams: 15 },
    { value: 'kk', label: 'kaf. kašičica', grams: 5 },
    { value: 'solja', label: 'šolja', grams: 250 },
];

const byValue = (u) => UNIT_OPTIONS.find(o => o.value === (u || 'g')) || UNIT_OPTIONS[0];

// kolicina u gramima (za racunanje kalorija)
export const gramsFor = (size, unit, pieceWeight) => {
    const u = byValue(unit);
    const factor = (u.value === 'kom' && Number(pieceWeight) > 0) ? Number(pieceWeight) : u.grams;
    return Number(size || 0) * factor;
};

// gramaza jedne stavke obroka/recepta (uvazava tezinu po komadu)
export const gramsForItem = (item) => gramsFor(
    item.servingSize,
    item.unit,
    item.pieceWeight != null ? item.pieceWeight : (item.ingredient && item.ingredient.pieceWeight)
);

// prikaz kolicine sa jedinicom: "50g", "50ml", "2 kom", "1 sup. kašika"
export const amountLabel = (size, unit) => {
    const u = byValue(unit);
    const s = Number(size || 0);
    const num = Number.isInteger(s) ? s : s.toFixed(1);
    return (u.value === 'g' || u.value === 'ml') ? `${num}${u.label}` : `${num} ${u.label}`;
};
